const data = {
	"width": 32,
	"height": 32,
	"body": "<path fill=\"currentColor\" d=\"M11 23a1 1 0 0 1-1-1V10a1 1 0 0 1 1.447-.894l12 6a1 1 0 0 1 0 1.788l-12 6A1.001 1.001 0 0 1 11 23Zm1-11.382v8.764L20.764 16Z\"/><path fill=\"currentColor\" d=\"M16 4A12 12 0 1 1 4 16A12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2Z\"/>"
};
export default data;
